
import { OldPermit as PermitModel } from "models";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class PermitExpansionPanel extends Vue {
  @Prop() readonly permit!: PermitModel;
}
